import posthog from 'posthog-js';

export const initializePostHog = () => {
  if (process.env.NODE_ENV === 'test' || typeof window === 'undefined') {
    return;
  }

  const apiKey = import.meta.env.VITE_POSTHOG_API_KEY;
  if (!apiKey) {
    console.warn('PostHog API key not provided. Analytics tracking disabled.');
    return;
  }

  posthog.init(apiKey, {
    api_host: import.meta.env.VITE_POSTHOG_API_HOST || 'https://app.posthog.com',
    autocapture: false, // Explicitly disable autocapture to avoid noisy data
    capture_pageview: false, // We will handle pageviews manually if needed
    debug: import.meta.env.DEV,
    loaded: (ph) => {
      if (import.meta.env.DEV) {
        // ph.opt_out_capturing(); // To uncomment in dev if you want to stop seeing your own events
      }
    },
  });
};

export const captureEvent = (eventName, properties = {}) => {
  posthog.capture(eventName, properties);
};

export const identifyUser = (userId, userProperties = {}) => {
  posthog.identify(userId, userProperties);
};

export const resetUser = () => {
  posthog.reset();
};

export const setPersonProperties = (properties) => {
  posthog.people.set(properties);
};

export default posthog;
